import { Component, OnInit } from '@angular/core';
import { ProjectService } from './services/project.service';

@Component({
  selector: 'app-project-results',
  templateUrl: './project-results.component.html',
  styleUrl: './project-results.component.scss'
})
export class ProjectResultsComponent implements OnInit {
  projects: any = [];
  selectedProject: any = null;
  running: boolean = false;
  constructor(private readonly projectService: ProjectService){ }

  ngOnInit() {
    this.projectService.getProjects().subscribe(_ => {
      this.projects = _;
    });
  }

  run() {
    this.running = true;
    this.projectService.getProjectResults(this.selectedProject.id).subscribe({
      next: (_: any) => {
        this.running = false;

        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(new Blob([_.body], { type: _.body.type }));
        const contentDisposition = _.headers.get('content-type');
        const fileName = "results.csv";
        downloadLink.download = fileName;
        downloadLink.click();
      },
      error: (_: any) => this.running = false
    });
  }
}
